<div class="manage-access-container">
  <h2 class="mt-4 mb-0">{{ tr('manageAccess') }}</h2>
  <div class="card mt-4 questionnaires ms-3">
    <div class="tabs">
      <p class="tablinks" routerLink="users" routerLinkActive="active">{{ tr('usersTab') }}</p>
      @if (!isUserManagement || isTenantAdmin || isPartnerAdmin) {
        <p class="tablinks" routerLink="tenants" routerLinkActive="active">{{ tr('tenantsTab') }}</p>
      }
      @if (!isUserManagement || isPartnerAdmin) {
        <p class="tablinks" routerLink="partners" routerLinkActive="active">Partners</p>
      }
      @if (!isUserManagement) {
        <p class="tablinks" routerLink="global-admins" routerLinkActive="active">Global Admins</p>
      }
      <p class="tablinks" routerLink="audit-log" routerLinkActive="active">{{ tr('auditLogTab') }}</p>
      @if (!isUserManagement) {
        <p class="tablinks" routerLink="pending-approvals" routerLinkActive="active">Pending Approval</p>
      }
    </div>

    <router-outlet></router-outlet>
  </div>
</div>
